import React, { useState, useRef, useEffect } from "react";
import { 
  StyledReadonlyTextField, 
  StyledEditTextField, 
  StyledTableCell 
} from './DTDataGridTextEdit.styles';

interface DTDataGridTextEditProps {
  text: string;
  cellKey: string;
  alignmentClass: string | undefined;
  dataChangeFunction?: (e: any, item: any) => void;
  rowIndex: number;
  itemName: string;
  editOnClick: boolean | undefined;
  foreColor: string | undefined;
  backColor: string | undefined;
}

const DTDataGridTextEdit: React.FC<DTDataGridTextEditProps> = (
  props: DTDataGridTextEditProps
) => {
  const [inEdit, setInEdit] = useState(false);
  const textFieldRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inEdit && textFieldRef.current) {
      setTimeout(() => {
        textFieldRef.current?.focus();
      }, 10);
    }
  }, [inEdit]);

  const handleClick = () => {
    if (props.editOnClick && !inEdit) {
      setInEdit(true);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setInEdit(false);
    e.target.blur();
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (props.editOnClick && !inEdit) {
      e.target.blur();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.dataChangeFunction) {
      props.dataChangeFunction(e, props.rowIndex);
    }
  };

  const inputProps = {
    readOnly: props.editOnClick ? !inEdit : true,
    style: {
      cursor: props.editOnClick && !inEdit ? 'pointer' : 'text',
      backgroundColor: inEdit ? 'white' : 'transparent'
    }
  };

  const commonProps = {
    hiddenLabel: true,
    name: props.itemName,
    margin: "none" as const,
    value: props.text ?? "",
    fullWidth: true,
    variant: "outlined" as const,
    size: "small" as const,
    inputRef: textFieldRef,
    InputProps: inputProps,
    onClick: handleClick,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
  };

  return (
    <StyledTableCell
      className={props.alignmentClass}
      sx={{ background: props.backColor }}
      tabIndex={0}
    >
      {inEdit ? (
        <StyledEditTextField
          {...commonProps}
          multiline={false}
          sx={{
            '& .MuiInputBase-input': { color: props.foreColor }
          }}
        />
      ) : (
        <StyledReadonlyTextField
          {...commonProps}
          multiline={true}
            minRows={1}
            maxRows={6}
            sx={{
              '& .MuiInputBase-input': { color: props.foreColor }
            }}
        />
      )}
    </StyledTableCell>
  );
};

export default DTDataGridTextEdit;